import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { Trans, useTranslation } from 'react-i18next';
import { MAX_SENSOR_STREAMS } from '../../../utils/sensor-stream-tracker';

interface StreamLimitDialogProps {
  open: boolean;
  message?: string;
  onClose: () => void;
}

const StreamLimitDialog = ({ open, message, onClose }: StreamLimitDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WarningIcon color="warning" />
        <Trans i18nKey="dashboard.streamLimit.warning.title">Sensor Stream Limit Reached</Trans>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          {message ||
            t('dashboard.streamLimit.warning.message', {
              defaultValue: 'You have reached the maximum number of sensor stream items ({{max}}). Please remove some widgets before adding more.',
              max: MAX_SENSOR_STREAMS,
            })}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          <Trans i18nKey="button.ok">OK</Trans>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StreamLimitDialog;
